<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-row no-gutters class="mb-4">
        <v-col cols="12" sm="4" md="4">
          <div class="d-flex mb-4">
            <div class="text-h4 font-weight-bold">{{$t("reportsB.healthReport")}}</div>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-tooltip top color="black" max-width="350">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="exportSemen"
              >
            <v-icon dark> mdi-export </v-icon>
          </v-btn>
            </template>
            <span>{{$t('reportsB.download')}}</span>
          </v-tooltip>
          
          <v-tooltip top color="black" max-width="350">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="
                  printPDF($refs.semen, 'Semen(Semen/Embryo Production Report)')
                "
              >
                <v-icon dark> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>{{$t('reportsB.print')}}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- filters -->
      <v-card class="mb-5 px-4 py-4 border rounded-lg" outlined>
        <v-row no-gutters>
          <v-col cols="12" sm="3" md="2">
            <label class="caption font-weight-normal">{{$t('reportsB.filterByMonth')}}</label>
            <v-select
              :items="months"
              item-text="label"
              item-value="value"
              dense
              outlined
              class="mr-2"
              v-model="month"
              placeholder="Filter By Month"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <label class="caption font-weight-normal">{{$t('reports.filterByDate')}}</label>
            <v-select
              :items="dates"
              dense
              outlined
              class="mr-2"
              v-model="date"
              placeholder="Filter By Date"
            ></v-select>
          </v-col>
          <!-- <v-col cols="12" sm="3" md="2">
            <label class="caption font-weight-normal">Filter By Role</label>
            <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class=""
              v-model="region"
            ></v-select>
          </v-col> -->
        </v-row>
      </v-card>

      <!-- chips -->

      <!-- <v-row no-gutters class="mb-4">
        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto border rounded-lg" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="black">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
    
              <v-list-item-content>
                <v-list-item-title class="text-h6 font-weight-bold">
                  Average Breeding Value
                </v-list-item-title>
                <v-list-item-subtitle class="mt-6 font-weight-medium">
                  <div class="d-flex flex-row">
                    <v-progress-linear value="85"></v-progress-linear
                    ><span class="ml-9">85%</span>
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
  
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="black">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
        
              <v-list-item-content>
                <v-list-item-title class="text-h6 font-weight-bold">
                  Average Economic Index
                </v-list-item-title>
                <v-list-item-subtitle class="mt-6 font-weight-medium">
                  <div class="d-flex flex-row">
                    <v-progress-linear value="71"></v-progress-linear
                    ><span class="ml-9">71%</span>
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row> -->

      <v-card elevation="0" flat color="transparent" class="pa-0 mx-auto border rounded-lg">
        <v-card-text class="pa-0">
          <v-card flat elevation="0" class="px-2 py-2" outlined>
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title class="text-h6 ml-n2">{{this.$t("reportsB.animalHealthRecord")}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <template v-slot:top> -->
              <!-- <div display="flex"> -->
              <!-- <v-text-field
                prepend-inner-icon="mdi-magnify"
                outlined
                placeholder="Search"
                dense
                class="shrink"
              ></v-text-field> -->
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon color="black">mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
              </v-menu>
            </v-toolbar>
            <v-card-text class="pa-0 black--text" ref="health">
              <v-data-table
                    :headers="healthHeaders"
                    :items="computedHealthData"
                    item-key="name"
                    class="elevation-0 rounded-table-header"
                    :items-per-page="5"
                  >
                  <template v-slot:item.treatment_date="{ item }">
                        {{  item.parasite_date && item.parasite_date && new Date(item.parasite_date).toISOString().split("T")[0] }}
                  </template>
                
              </v-data-table>
            </v-card-text>
          </v-card>

          <v-card flat elevation="0" outlined class="mt-5 px-2 py-2">
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title class="text-h6 ml-n2">{{$t('reportsB.animalTreatmentRecord')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon color="black">mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
              </v-menu>
            </v-toolbar>
            <v-card-text class="pa-0">
              <div ref="treatment">
                <v-data-table
                  :headers="treatmentHeaders"
                  :items="computedTreatment"
                  :items-per-page="5"
                  class="elevation-0 rounded-table-header"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      color="primary"
                      :height="6"
                      indeterminate
                    ></v-progress-linear>
                  </template>
                  <template v-slot:item.treatment_date="{ item }">
                        {{  item.treatment_date && item.treatment_date && new Date(item.treatment_date).toISOString().split("T")[0] }}
                </template>
                <template v-slot:item.treatment_end_date="{ item }">
                        {{  getTreatmentProgress(item.treatment_date, item.treatment_end_date ) }}
                        <v-progress-linear
                            :value="getTreatmentProgress(item.treatment_date, item.treatment_end_date )"
                            color="primary"
                          ></v-progress-linear>
                </template>
        
                  <!-- <template v-slot:footer></template> -->
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
          <v-row class="mt-5">
            <v-col cols="6">
              <v-card flat elevation="0" outlined class="pa-2">
                <v-toolbar dense flat :elevation="0">
                  <v-toolbar-title class="text-h6 ml-n2">{{$t("reportsB.animalInseminationRecord")}}</v-toolbar-title>
                  <v-spacer></v-spacer>


                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="black">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <div ref="insemi">
                    <v-data-table
                      :headers="insemintorHeaders"
                      :items="inseminatorData"
                      :items-per-page="5"
                      hide-default-footer
                      :loading="loadingInseminator"
                      loading-text="Loading Data..."
                      :options.sync="inseminatorOptions"
                      :server-items-length="5"
                      class="elevation-0 rounded-table-header"
                    >
                      <template v-slot:progress>
                        <v-progress-linear
                          color="primary"
                          :height="6"
                          indeterminate
                        ></v-progress-linear>
                      </template>
              
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card flat elevation="0" outlined class="pa-2">
                <v-toolbar dense flat :elevation="0">
                  <v-toolbar-title class="text-h6 ml-n2">{{$t("reportsB.animalVaccinationRecord")}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="black">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <div ref="vaccine">
                    <v-data-table
                    :headers="animalVaccineHeaders"
                    :items="computedVaccination"
                    item-key="name"
                    class="elevation-0 rounded-table-header"
                    :items-per-page="5"
                  >
                  <template v-slot:item.vaccination_date="{ item }">
                        {{  item.vaccination_date && item.vaccination_date && new Date(item.vaccination_date).toISOString().split("T")[0] }}
                </template>
                
                </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import HealthReport from "@/_services/AnalyticsService";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import { animalHealths } from "@/graphql/Health.gql";

export default {
   apollo: {
    healthData: {
      query: animalHealths,
      fetchPolicy: 'network-only',
      update: data => data.healths,
      result() {
        let monthDays = this.daysInMonth(this.month)
        this.month = new Date().getMonth()
        this.date = new Date().getDate()

        for(let i =0; i< monthDays; i++) {
            this.dates.push(i + 1)
        }
      }
    },
  },
  mounted() {
    document.title = "Analytics and Reporting";
  },
  computed: {},
  created() {},
  watch: {
    month: {
      handler(nV) {
        // console.log('nvv', nV)
        if (this.healthData && this.healthData.rows) {
          this.computedHealthData = this.healthData.rows.filter(hd => {
            let tmpDate = new Date(hd.parasite_date)
            console.log('hdd', nV, tmpDate.getUTCMonth(), this.date, tmpDate.getUTCDate())
            return (nV == tmpDate.getUTCMonth()) && (this.date == tmpDate.getUTCDate())
          })
          console.log('sljdlksfj', this.computedHealthData)
          this.computedTreatment = this.healthData.rows.filter(hd => {
            let tmpDate = new Date(hd.treatment_date)
            if((nV == tmpDate.getUTCMonth()) && (this.date == tmpDate.getUTCDate())) {
              return true
            }
          })
          this.computedVaccination = this.healthData.rows.filter(hd => {
            let tmpDate = new Date(hd.vaccination_date)
            if((nV == tmpDate.getUTCMonth()) && (this.date == tmpDate.getUTCDate())) {
              return true
            }
          })
        }
      },
      immediate: true
    },
    date: {
      handler(nV) {
        if (this.healthData && this.healthData.rows) {
          this.computedHealthData = this.healthData.rows.filter(hd => {
            let tmpDate = new Date(hd.parasite_date)
            if((nV == tmpDate.getUTCDate()) && (this.month == tmpDate.getUTCMonth()) ) {
              return true
            }
          })
          this.computedTreatment = this.healthData.rows.filter(hd => {
            let tmpDate = new Date(hd.treatment_date)
            if((nV == tmpDate.getUTCDate()) && (this.month == tmpDate.getUTCMonth()) ) {
              return true
            }
          })
          this.computedVaccination = this.healthData.rows.filter(hd => {
            let tmpDate = new Date(hd.vaccination_date)
            if((nV == tmpDate.getUTCDate()) && (this.month == tmpDate.getUTCMonth()) ) {
              return true
            }
          })
        }
      },
      immediate: true
    },
    healthOptions: {
      handler() {
        this.getAnimalHealthReport();
      },
      deep: true,
    },
    treatmentOptions: {
      handler() {
        this.getAnimalTreatmentReport();
      },
      deep: true,
    },
    inseminatorOptions: {
      handler() {
        this.getAnimalInseminatorReport();
      },
      deep: true,
    },
  },
  methods: {
   daysInMonth (month, year = new Date().getFullYear()) {
      return new Date(year, month, 0).getDate();
  },
    getTreatmentProgress(startDate, endDate) {
      let sDate = new Date(startDate)
      let eDate = new Date(endDate)
      let today = new Date()

      if(eDate.getTime() < today.getTime()) {
        return 100
      } else {
        let totalDays = (eDate.getTime() - sDate.getTime()) / 8.64e+7
        let completedDays = (today.getTime() - sDate.getTime()) / 8.64e+7
  
        return ((completedDays/totalDays) * 100).toFixed(2)
      }



    },
    exportSemen() {

    },
    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 1, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    // getAnimalHealthReport() {
    //   this.loadingHealth = true;
    //   HealthReport.getHealthReport(this.healthOptions, "")
    //     .then((res) => {
    //       this.healthData = res.data.data.healthRecord.rows;
    //       this.totalHealth = res.data.data.healthRecord.total_rows;
    //       this.totalHealthPages = Math.ceil(
    //         this.totalHealth / this.healthOptions.itemsPerPage
    //       );
    //       this.healthFrom =
    //         (this.healthOptions.page - 1) * this.healthOptions.itemsPerPage + 1;
    //       this.healthTo =
    //         this.healthOptions.page * this.healthOptions.itemsPerPage -
    //         (this.healthOptions.itemsPerPage - res.data.departments.num_rows);
    //       this.loadingHealth = false;
    //     })
    //     .catch((err) => {
    //       this.loadingHealth = false;
    //       console.log(err);
    //     });
    // },
    getAnimalTreatmentReport() {
      this.loadingTreatment = true;
      HealthReport.getTreatmentReport(this.treatmentOptions, "")
        .then((res) => {
          this.loadingTreatment = false;
          this.treatmentData = res.data.data.treatmentRecord.rows;
          this.totalTreatment = res.data.data.treatmentRecord.total_rows;
          this.totalTreatmentPages = Math.ceil(
            this.totalTreatment / this.treatmentOptions.itemsPerPage
          );
          this.treatmentFrom =
            (this.treatmentOptions.page - 1) *
              this.treatmentOptions.itemsPerPage +
            1;
          this.treatmentTo =
            this.treatmentOptions.page * this.treatmentOptions.itemsPerPage -
            (this.treatmentOptions.itemsPerPage -
              res.data.departments.num_rows);
          this.loadingHealth = false;
        })
        .catch((err) => {
          this.loadingTreatment = false;
          console.log(err);
        });
    },
    getAnimalInseminatorReport() {
      this.loadingInseminator = true;
      HealthReport.getInseminatorReport(this.inseminatorOptions, "")
        .then((res) => {
          this.loadingInseminator = false;
          this.inseminatorData = res.data.data.insemenationRecord;
          //   this.totalInseminator = res.data.animalConception.totalRows;
        })
        .catch((err) => {
          this.loadingInseminator = false;
          console.log(err);
        });
    },
    pageHealthChange(t) {
      if (t) this.healthOptions.page = this.healthOptions.page + 1;
      else this.healthOptions.page = this.healthOptions.page - 1;

      this.getAnimalHealthReport();
    },
    pageTreatmentChange(t) {
      if (t) this.treatmentOptions.page = this.treatmentOptions.page + 1;
      else this.treatmentOptions.page = this.treatmentOptions.page - 1;

      this.getAnimalTreatmentReport();
    },
    exporthealth() {
      html2pdf(this.$refs.health, {
        margin: 1,
        filename: "Health Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportreatment() {
      html2pdf(this.$refs.treatment, {
        margin: 1,
        filename: "Treatment Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportinsemination() {
      html2pdf(this.$refs.insemi, {
        margin: 1,
        filename: "Insemination Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportvaccine() {
      html2pdf(this.$refs.vaccine, {
        margin: 1,
        filename: "Vaccination Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
  },
  data: () => ({
    computedHealthData: [],
    computedTreatment: [],
    computedVaccination: [],
    months: [
       { label: 'Jan', value: 0 },
        { label: 'Feb', value: 1 },
        { label: 'Mar', value: 2 },
        { label: 'Apr', value: 3 },
        { label: 'May', value: 4 },
        { label: 'Jun', value: 5 },
        { label: 'Jul', value: 6 },
        { label: 'Aug', value: 7 },
        { label: 'Sep', value: 8 },
        { label: 'Oct', value: 9 },
        { label: 'Nov', value: 10 },
        { label: 'Dec', value: 11 },
    ],
    month: 0,
    dates: [],
    date: 0,
    healths: [],
    loadingHealth: false,
    loadingTreatment: false,
    loadingInseminator: false,
    countries: [],
    regions: [],
    totalHealthPages: 0,
    totalTreatmentPages: 0,
    countary: null,
    region: null,
    healthFrom: 0,
    healthTo: 0,
    treatmentFrom: 0,
    treatmentTo: 0,
    totalHealth: 0,
    totalTreatment: 0,
    totalInseminator: 0,
    healthOptions: {},
    treatmentOptions: {},
    inseminatorOptions: {},
    healthHeaders: [
      {
        text: "Animal ID",
        align: "start",
        sortable: false,
        value: "animalId.id",
      },
      { text: "Name Of Diagnosis", value: "name_of_diagnosis" },
      { text: "Drug Name", value: "treatment_drug_name" },
      { text: "Drug Withdrawal Period", value: "drug_withdrawal_period" },
      { text: "Treatment Date", value: "treatment_date" }
    ],
    treatmentHeaders: [
      {
        text: "Animal ID",
        align: "start",
        sortable: false,
        value: "animalId.id",
      },
      { text: "Drug Given By", value: "attending_vetenarian" },
      { text: "Treatment Name", value: "treatment_name" },
      { text: "Treatment Date", value: "treatment_date" },
      { text: "Reason Of Treatment", value: "reason_of_treatment" },
      { text: "Recovery Status", value: "treatment_end_date" },
    ],
    insemintorHeaders: [
      {
        text: "Animal ID",
        align: "start",
        sortable: false,
        value: "animalNumber",
      },
      { text: "Inseminator Name", value: "inseminatorName" },
      { text: "Inseminator Success", value: "id" },
      { text: "Date of Insemination", value: "matingDate" },
    ],
    animalVaccineHeaders: [
      {
        text: "Animal ID",
        align: "start",
        sortable: false,
        value: "animalId.id",
      },
      { text: "Veterinarian Name", value: "veterinarian_name" },
      { text: "Type Of Vaccine", value: "vaccination_type" },
      { text: "Date of Vaccination", value: "vaccination_date" },
    ],
    treatmentData: [],
    inseminatorData: [],
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Analytics and Reporting",
        disabled: true,
      },
      {
        text: "Health Report",
        disabled: true,
      },
    ],
  }),
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
</style>